import { useEffect, useState } from 'react';

export default class ProxyLocalStorage {
  Telegram;
  prefix: string = 'tomo-tg-wallet-sdk-';
  userId: string = '';
  constructor() {
    if (typeof window != 'undefined') {
      this.Telegram = window.Telegram;
      if (!this.Telegram) {
        throw `[TOMO] please include https://telegram.org/js/telegram-web-app.js in your project`;
      }
      const initDataUnsafe = this.Telegram.WebApp.initDataUnsafe || {
        user: { id: '' },
      };
      const userId = initDataUnsafe?.user?.id || '';
      this.userId = userId;
    }
  }
  get(key, withTgUserId: boolean = true) {
    if (typeof window === 'undefined') return null;
    const oKey = withTgUserId
      ? `${this.prefix}${key}_${this.userId}`
      : `${this.prefix}${key}`;
    try {
      let value = localStorage.getItem(oKey);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      console.log(error);
      return null;
    }
  }
  set(key, value, withTgUserId: boolean = true) {
    if (typeof window === 'undefined') return null;
    const oKey = withTgUserId
      ? `${this.prefix}${key}_${this.userId}`
      : `${this.prefix}${key}`;
    try {
      localStorage.setItem(oKey, JSON.stringify(value));
      return value;
    } catch (error) {
      return null;
    }
  }
}

export function useProxyLocalStorage() {
  const [storage, setStorage] = useState(({
    get() {
      console.warn('local storage proxy not created yet');
      return '';
    },
    set() {
      console.warn('local storage proxy not created yet');
      return '';
    },
  } as unknown) as InstanceType<typeof ProxyLocalStorage>);

  useEffect(() => {
    setStorage(new ProxyLocalStorage());
  }, []);

  return storage;
}
